<script>
import { BButtonGroup, BDropdown, BDropdownItem, BDropdownDivider } from 'bootstrap-vue';
import { Alert } from '../../services/alert';

export default {
  components: {
    BDropdown,
    BButtonGroup,
    BDropdownItem,
    BDropdownDivider,
  },

  props: {
    expired: false,
    invite_id: String,
    invite_url: String,
  },

  data () {
    return {
    };
  },

  methods: {
    copyInvite() {
      window.navigator.clipboard.writeText(this.invite_url);
      Alert.success('URL de convite copiada!');
    },
    sendAction(type) {
      this.$http.put(`user/invite/${this.invite_id}/actions`, {
        action: type
      }).then(response => {
        if(type === 'resend') {
          Alert.success('Convite reenviado!');
        }
        if(type === 'cancel') {
          location.reload();
        }
      }).catch(err => {
        let msg = 'Houve um erro ao realizar a ação';
        if(type === 'resend') msg = 'Erro ao reenviar o convite!'
        if(type === 'cancel') msg = 'Erro ao cancelar o convite!'
        Alert.error(msg);
      });
    }
  }
};
</script>

<template>
  <div>
    <BButtonGroup
      class="dropdown"
    >
      <BDropdown
        no-caret
        variant="link"
        class="nav-action nav-profile"
        toggle-class="text-decoration-none p-0"
        menu-class="bdk-segment-actions__dropdown"

      >
        <template #button-content>
          <button
            type="button"
            aria-haspopup="true"
            aria-expanded="false"
            class="segment-actions"
          >
            <i
              class="fa fa-angle-down pr-1"
            />
            {{ __('Ações') }}
          </button>
        </template>
        <template v-if="!expired">
          <BDropdownItem
              href="#"
              :key="'copy_action'"
              @click.prevent="copyInvite()"
            >
              <i class="fa fa-copy mr-2" style="font-size: 12px"> </i> {{ __('Copiar link do convite') }}
          </BDropdownItem>
        </template>
          <BDropdownItem
          href="#"
          :key="'cancel_action'"
          @click.prevent="sendAction('cancel')"
        >
          <i class="fa fa-trash-o mr-2" style="font-size: 12px"/> {{ __('Cancelar convite') }}
        </BDropdownItem>
        <BDropdownItem
          href="#"
          :key="'reesend_action'"
          @click.prevent="sendAction('resend')"
        >
          <i class="fa fa-paper-plane mr-2" style="font-size: 12px"/> {{ __('Reenviar convite') }}
         </BDropdownItem>
      </BDropdown>
    </BButtonGroup>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../../sass/variables";

  .segment-actions {
    border-radius: 14px;
    border: 0;
    outline: 1px solid $salesflow-outline-gray-medium;
    background-color: $salesflow-outline-gray-light;
    height: 30px;
    width: 84px;
    font-size: 0.75rem;
  }

  ::v-deep .dropdown-menu {
    max-height: 200px;
    margin: 8px 20px;
    width: 250px !important;
    padding: 0;
    border: 0;
  }

  a:hover {
    text-decoration: none;
  }
</style>
